import React from 'react';
import classNames from 'classnames';
import { CloseIcon } from '../../Icons';
import withDelayedHovering from './Utils/withDelayedHovering';

var User = function User(_ref) {
  var name = _ref.name,
      _ref$onRemove = _ref.onRemove,
      onRemove = _ref$onRemove === void 0 ? function () {
    return true;
  } : _ref$onRemove,
      userId = _ref.userId,
      _ref$hovering = _ref.hovering,
      hovering = _ref$hovering === void 0 ? false : _ref$hovering;
  return React.createElement("div", {
    "data-editor": "mention-".concat(userId),
    className: classNames('flexbox flexbox-align-center', 'entity-highlight', 'font-weight-medium ellipsis transition', hovering ? 'padding-horizontal-smaller' : 'padding-horizontal-normal'),
    style: {
      display: 'inline-flex'
    }
  }, React.createElement("div", null, "@".concat(name)), React.createElement("div", {
    className: "overflow-hidden transition flexbox flexbox-align-center pointer",
    onClick: onRemove,
    style: {
      width: hovering ? 16 : 0,
      height: 16,
      paddingLeft: hovering ? 4 : 0,
      paddingRight: hovering ? 4 : 0
    }
  }, React.createElement(CloseIcon, {
    "data-editor": "mention-delete-".concat(userId),
    size: 8
  })));
};

export default React.memo(withDelayedHovering(User));